import i18n from '@i18n';

// ExampleQueries.js
interface ExampleQueriesOptions {
	target: string | HTMLElement; // Selector or DOM element where the queries will be appended
	title?: string; // Optional title for the example queries section
	queries: string[]; // Array of example queries
}

/**
 * Creates and appends a list of example queries to the target container.
 *
 * @param options - Configuration options for the example queries
 * @returns The created container element
 */
export function ExampleQueries({
	target,
	title,
	queries,
}: ExampleQueriesOptions): HTMLElement {
	const container = document.createElement('div');
	container.classList.add('example-queries');

	// Add title if provided
	if (title) {
		const titleElement = document.createElement('h2');
		titleElement.textContent = title;
		container.appendChild(titleElement);
	}

	// Create the list of queries
	const list = document.createElement('ul');

	queries.forEach((query) => {
		const listItem = document.createElement('li');
		listItem.textContent = query;
		listItem.setAttribute('data-query', query);

		// Add click event to populate the search input
		listItem.addEventListener('click', () => {
			const input = document.querySelector('.aex-search-form input[type="search"]') as HTMLInputElement | null;
			if (input) {
				input.value = query;
				input.dispatchEvent(new Event('input'));
			}
		});

		list.appendChild(listItem);
	});

	container.appendChild(list);

	// Append the container to the target
	if (typeof target === 'string') {
		const targetElement = document.querySelector(target);
		if (targetElement) {
			targetElement.appendChild(container);
		} else {
			console.error(`${i18n.t('error.targetError', { prefix: i18n.t('log.prefix') })}: ${target}`);
		}
	} else if (target instanceof HTMLElement) {
		target.appendChild(container);
	} else {
		console.error(`${i18n.t('error.targetError', { prefix: i18n.t('log.prefix') })}`);
	}

	return container;
}
